export default {
  search: 'Hledat',
  searchPlaceholder: 'Hledat hry...',
  logIn: 'Přihlásit se',
  signUp: 'Registrovat se',
  logOut: 'Odhlásit se',
  account: 'Účet',
  myOrders: 'Mé objednávky',
  favorites: 'Oblíbené',
  cart: 'Košík',
  viewMore: 'Zobrazit více',
  browseCatalog: 'Procházet katalog',
  startingAt: 'Od',
  baseGame: 'Základní hra',
  retry: 'Zkusit znovu',
  close: 'Zavřít',
  loading: 'Načítání…',
  noImage: 'Bez obrázku',
  searchCountry: 'Hledat zemi…',
  noResults: 'Žádné výsledky',
};
